import * as Sentry from '@sentry/react'
import { useAppDispatch } from '../../../store/hooks'
import { addToast } from '../../../store/toast/toastSlice'
import { invitationEmailText, type InvitationEmailInput } from './invitationEmailText'

export const useCopyInvitationEmail = () => {
  const dispatch = useAppDispatch()

  return async (input: InvitationEmailInput) => {
    try {
      await navigator.clipboard.writeText(invitationEmailText(input))
      dispatch(addToast({ variant: 'success', title: 'Email copied', messages: ['Paste it into your email client to edit and send.'] }))
    } catch (error) {
      Sentry.captureException(error)
      dispatch(addToast({ variant: 'error', title: 'Could not copy the email', messages: ['Please try again.'] }))
    }
  }
}
